import {fetchVariations} from "@/store/api/api";

export default {
    namespaced: true,
    state: {
        id: null,
        variations: [],
    },
    getters: {
        getCurrentVariationId: (state) => state.id,
        getCurrentVariation: (state) =>
            state.variations.find(variation => variation.id === state.id),
        getVariationsByDescIncludes: (state) => (str) => {
            if (str) return state.variations.filter((variation) => {
                    return variation.desc
                        .toLowerCase()
                        .includes(str.toLowerCase().trim());
                }
            );
            return state.variations;
        },
        isVariationExist: (state) => (id) =>
            state.variations.some(variation => variation.id === id)
    },
    mutations: {
        setVariations(state, payload) {
            state.variations = payload;
        },
        setCurrentVariation(state, payload) {
            state.id = parseInt(payload);
        },
        clearVariation(state) {
            state.id = null;
        },
    },
    actions: {
        async fetchVariations({commit}, options) {
            const items = await fetchVariations(options);
            commit('setVariations', items);
        },
        setCurrentVariation({commit, dispatch}, id) {
            commit('setCurrentVariation', id);
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearVariation({commit, dispatch}) {
            commit('clearVariation');
            dispatch('clearVariationDependencies');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearVariationDependencies({dispatch}) {
            dispatch('event/clearEvents', null, {root: true});
            dispatch('places/clearPlaces', null, {root: true});
        }
    }
}
